import { render, staticRenderFns } from "./LandlordProfile.vue?vue&type=template&id=1545c720&scoped=true&"
import script from "./LandlordProfile.vue?vue&type=script&lang=js&"
export * from "./LandlordProfile.vue?vue&type=script&lang=js&"
import style0 from "./LandlordProfile.vue?vue&type=style&index=0&id=1545c720&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1545c720",
  null
  
)

export default component.exports